<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab">
        <el-tab-pane label="入库记录" name="first" :lazy="true">
          <div v-if="activeName=='first'">
            <div class="formBox margbot" ref="searchBox">
              <el-form :inline="true" :model="formData" size="mini"   label-width="90px">
                <div class="formItemBox" >
                <el-form-item label="入库单号:">
                  <el-input class="ipt" v-model="formData.instockNo" placeholder="请输入" size="mini" >
                  </el-input>
                </el-form-item>
                <el-form-item label="车辆号牌:">
                  <el-input class="ipt" v-model="formData.instockPlateNumber" placeholder="请输入" size="mini" ></el-input>
                </el-form-item>
                <el-form-item label="一级货主:">
                  <el-select size="mini" filterable clearable placeholder="请选择" v-model="formData.primaryCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="二级货主:">
                  <el-select size="mini" clearable filterable placeholder="请选择" v-model="formData.customerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="货物类型:">
                  <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
                    <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="产地:">
                  <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
                    <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="规格:">
                  <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
                    <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="材质:">
                  <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
                    <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="入库日期:">
                <div style="display: flex;">
                  <el-date-picker v-model="formData.instockDateStart" size="mini" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  -
                  <el-date-picker v-model="formData.instockDateEnd" size="mini" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </div>
                </el-form-item>
                <el-form-item label="到货方式:">
                  <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
                    <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注:">
                  <el-input class="ipt" v-model="formData.ext1" placeholder="请输入" size="mini" ></el-input>
                </el-form-item>
               </div>
               <div>
                <el-form-item>
                  <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP007B001" v-if="btnFlg[0]">查询
                  </el-button>
                  <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP007B002" v-if="btnFlg[1]">重置
                  </el-button>
                  <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP007B003" v-if="btnFlg[2]">导出
                  </el-button>
                  <el-button type="primary" size="mini" @click="shanchu" btnCode="00ZP007B004" v-if="btnFlg[3]">删除
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <span>
                    总吨数：
                    <span style="color: red">{{ allWeight }}</span> &nbsp;吨
                  </span>
                  <span style="margin-left: 20px">
                    总件数：
                    <span style="color: red">{{ allNumber }}</span> &nbsp;件
                  </span>
                </el-form-item>
               </div>

              </el-form>
            </div>
            <div :style="{height:h}">
              <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @selection-change="selectGoods">
                <el-table-column type="selection" align="center" width="40"></el-table-column>
                <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                <el-table-column align="center" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button type="text" @click="lookImg(scope.row)" size="mini">查看单据</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="organizationName" label="仓库名称" width="200"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" width="100">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="outNumber" label="出厂车号" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="180"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="120">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehousingNo" label="出厂编号" align="center" width="150"></el-table-column>
                 <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center" width="150"></el-table-column>
              </el-table>
            </div>
            <div class="pags">
              <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="进仓记录" name="second" :lazy="true">
          <jc-record v-if="JCVisible && activeName=='second'" :JCVisible.sync="JCVisible"></jc-record>
        </el-tab-pane>
        <el-tab-pane label="出库记录" name="third" :lazy="true">
          <ck-record v-if="CKVisible && activeName=='third'" :CKVisible.sync="CKVisible"></ck-record>
        </el-tab-pane>
        <el-tab-pane label="出库明细" name="ckmx" :lazy="true" btnCode="00ZM0E0G00" v-if="btnFlg[44]">
          <ck-mingxi v-if="CKMXVisible && activeName=='ckmx'" :CKMXVisible.sync="CKMXVisible"></ck-mingxi>
        </el-tab-pane>
        <el-tab-pane label="转货记录" name="fourth" :lazy="true">
          <zh-record v-if="ZHVisible && activeName=='fourth'" :ZHVisible.sync="ZHVisible"></zh-record>
        </el-tab-pane>
        <el-tab-pane label="转货明细" name="zhmx" :lazy="true" btnCode="00ZM0E0H00" v-if="btnFlg[45]">
          <zh-mingxi v-if="ZHMXVisible && activeName=='zhmx'" :ZHMXVisible.sync="ZHMXVisible"></zh-mingxi>
        </el-tab-pane>
        <el-tab-pane label="控货记录" name="twelve" :lazy="true">
          <cargo-record v-if="cargoVisible && activeName=='twelve'" :cargoVisible.sync="cargoVisible"></cargo-record>
        </el-tab-pane>
        <el-tab-pane label="移库记录" name="fifth" :lazy="true">
          <yk-record v-if="YKVisible && activeName=='fifth'" :YKVisible.sync="YKVisible"></yk-record>
        </el-tab-pane>
        <el-tab-pane label="客户亏涨记录" name="sixth" :lazy="true">
          <kh-record v-if="KHVisible && activeName=='sixth'" :KHVisible.sync="KHVisible"></kh-record>
        </el-tab-pane>
        <el-tab-pane label="入库亏涨记录" name="rukukz" :lazy="true" btnCode="00ZM0E0F00" v-if="btnFlg[43]">
          <ruku-kuizhang v-if="KHVisible && activeName=='rukukz'" :rukukzVisible.sync="rukukzVisible"></ruku-kuizhang>
        </el-tab-pane>
        <el-tab-pane label="仓位亏涨记录" name="seventh" :lazy="true">
          <cw-record v-if="CWVisible && activeName=='seventh'" :CWVisible.sync="CWVisible"></cw-record>
        </el-tab-pane>
        <el-tab-pane label="删除记录" name="eighth" :lazy="true">
          <sc-record v-if="SCVisible && activeName=='eighth'" :SCVisible.sync="SCVisible"></sc-record>
        </el-tab-pane>
        <el-tab-pane label="撤销记录" name="ninth" :lazy="true">
          <cx-record v-if="CXVisible && activeName=='ninth'" :CXVisible.sync="CXVisible"></cx-record>
        </el-tab-pane>
        <el-tab-pane label="撤销进仓确认记录" name="tenth" :lazy="true">
          <jccx-record v-if="JccxVisible && activeName=='tenth'" :JccxVisible.sync="JccxVisible"></jccx-record>
        </el-tab-pane>
        <el-tab-pane label="撤销二次分货记录" name="eleventh" :lazy="true">
          <eccx-record v-if="EccxVisible && activeName=='eleventh'" :EccxVisible.sync="EccxVisible"></eccx-record>
        </el-tab-pane>

      </el-tabs>
    </div>
    <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  JfgetInStockExpList,
  getVirtualBalingList,
  JfdeleteInStockExp,
  getInStockExpNumber
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
import JcRecord from './JCRecord.vue'
import CkRecord from './CKRecord.vue'
import ZhRecord from './ZHRecord.vue'
import YkRecord from './YKRecord.vue'
import KhRecord from './KHRecord.vue'
import RukuKuizhang from './rukuKuizhang.vue'
import ZhMingxi from './ZHMingxi.vue'
import CkMingxi from './CKMingxi.vue'
import CwRecord from './CWRecord.vue'
import ScRecord from './SCRecord.vue'
import CxRecord from './CXRecord.vue'
import CargoRecord from './CargoRecord.vue'
import JccxRecord from './JccxRecord.vue'
import EccxRecord from './EccxRecord.vue'
import djDialog from '../../ruku/dialog/DJindex'
export default {
  components: {
    JcRecord,
    CkRecord,
    CargoRecord,
    ZhRecord,
    YkRecord,
    KhRecord,
    CwRecord,
    ScRecord,
    CxRecord,
    RukuKuizhang,
    ZhMingxi,
    CkMingxi,
    djDialog,
    JccxRecord,
    EccxRecord
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      total: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      formData: {
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockDateStart: '',
        instockDateEnd: '',
        arrivalMethod: '',
        ext1: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      btnArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U',
        '00ZM0E0100',
        '00ZM0E0200',
        '00ZM0E0300',
        '00ZM0E0400',
        '00ZM0E0500',
        '00ZM0E0600',
        '00ZM0E0700',
        '00ZM0E0800',
        // '00ZM0E0900',
        '00ZM0E0A00',
        '00ZM0E0B00',
        '00ZM0E0C00',
        '00ZM0E0D00',
        '00ZM0E0E00',
        '00ZM0E0F00',
        '00ZM0E0G00',
        '00ZM0E0H00'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      selectListId: [],
      selectList: [],
      JCVisible: true,
      CKVisible: true,
      CKMXVisible: true,
      ZHVisible: true,
      ZHMXVisible: true,
      YKVisible: true,
      KHVisible: true,
      rukukzVisible: true,
      CWVisible: true,
      SCVisible: true,
      CXVisible: true,
      JccxVisible: true,
      EccxVisible: true,
      cargoVisible: true,
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      CKDJVisible: false,
      instockId: '',
      allWeight: 0,
      allNumber: 0
    }
  },
  methods: {
    // 总吨数
    getInStockExpNumber () {
      getInStockExpNumber({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        arrivalMethod: this.formData.arrivalMethod,
        ext1: this.formData.ext1
      }).then(res => {
        console.log(res)
        if (res.length != 0) {
          this.allWeight = parseFloat(res.totalAllWeight.toFixed(6))
          // this.allWeight = res.totalAllWeight
          this.allNumber = res.totalNumber
        } else {
          this.allWeight = 0
          this.allNumber = 0
        }
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    handleClicktab (tab, event) {
      // this.getControlAuditLists()
      this.chongzhi()
    },
    timeStamp: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    getNowTime () {
      let newTime = this.timeStamp(new Date())
      this.formData.instockDateEnd = newTime
      this.formData.instockDateStart = this.timeStamp(new Date(newTime).getTime() - (86400000 * 3))
      this.JfgetInStockExpLists()
    },
    // 列表查询
    JfgetInStockExpLists () {
      JfgetInStockExpList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        instockDateStart: this.formData.instockDateStart,
        instockDateEnd: this.formData.instockDateEnd,
        arrivalMethod: this.formData.arrivalMethod,
        ext1: this.formData.ext1
      })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          this.tableData.forEach(item => {
            item.allWeight = parseFloat(Number(item.allWeight).toFixed(6))
            item.weight = parseFloat(Number(item.weight).toFixed(6))
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.inDetailId) // id数组
        arry = Array.from(new Set(arry)) // 去重
        this.selectListId = arry.join(',') // 获取全部货物id
      })
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.selectList.length == 0) {
        DonMessage.error('请先选择一条数据')
        return
      } else if (this.selectList.length > 1) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.$confirm('删除后数据不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        JfdeleteInStockExp({
          instockSummaryId: this.selectList[0].instockSummaryId
        })
          .then(res => {
            DonMessage.success('删除成功')
            this.JfgetInStockExpLists()
            this.getInStockExpNumber()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      this.JfgetInStockExpLists()
      this.getInStockExpNumber()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.customerTaxId = ''
      this.formData.arrivalMethod = ''
      this.formData.ext1 = ''
      // this.formData.instockDateStart = ''
      // this.formData.instockDateEnd = ''
      this.getNowTime()
      this.JfgetInStockExpLists()
      this.getVirtualBalingList()
      this.getInStockExpNumber()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportInStockExpList', {
          ...this.formData,
          instockStatus: '1'
        },
        '入库记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetInStockExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetInStockExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  },
  updated () {
    var _this = this
    if (_this.activeName == 'first') {
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {
          // console.log('123')
          _this.chaxun()
        }
      }
    }
  },
  created () {
    this.getNowTime()
    this.btnFlg = getBtn(this.btnArr, '/recordQuery')
    console.log(this.btnFlg, 'this.btnFlg')
    this.getRelationCustomerS()
    this.JfgetInStockExpLists()
    this.getVirtualBalingList()
    this.getInStockExpNumber()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
  }
}

</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}
/deep/ .el-tabs__header{
  margin-bottom: 0!important;;
}

</style>
